export default __webpack_public_path__ + "static/media/Signin.ffe0c8d4.png";